import React, { useEffect, useMemo, useState } from 'react';
import { Box, Drawer, List, ListItem, Typography, Divider, Button, Avatar, FormControlLabel, Checkbox, TextField, Modal, Fade, Backdrop, Slide, Slider, Select, MenuItem, FormControl, InputLabel, CircularProgress, Pagination } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Grid from '@mui/material/Grid2';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import LeadListFilters from './LeadListFilters';
import debounce from 'lodash/debounce';
import Papa from 'papaparse';
import { saveAs } from 'file-saver';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Chip } from '@mui/material';
import { locationsDict } from '../utilities/constants';

function LeadDetails({ selectedLead, onClose }) {

  const [realEstate, setRealEstate] = useState([]);
  const [realEstateTransactions, setRealEstateTransactions] = useState([]);
  const [insiderTrades, setInsiderTrades] = useState([]);
  const [companyDeals, setCompanyDeals] = useState([]);
  const [selectedLead401k, setSelectedLead401k] = useState([]);
  const [employmentHistory, setEmploymentHistory] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
      axios.get(`https://api.pathvizor.com/employment_history/${selectedLead.lead_id}`)
        .then((response) => {
          setEmploymentHistory(response.data.sort((a, b) => new Date(b.start_date) - new Date(a.start_date)));
        })
        .catch(() => {
          setEmploymentHistory([]);
        });
      axios.get(`https://api.pathvizor.com/leads/${selectedLead.lead_id}/401k`) // Replace with your API endpoint
        .then((response) => {
          setSelectedLead401k(response.data);
        })
        .catch(() => {
          setSelectedLead401k(null);
        });
      axios.get(`https://api.pathvizor.com/insider_trades/${selectedLead.cik}`) // Replace with your API endpoint
        .then((response) => {
          setInsiderTrades(response.data.sort((a, b) => new Date(b.transaction_date) - new Date(a.transaction_date)));
        })
        .catch(() => {
          setInsiderTrades(null);
        });
        axios.get(`https://api.pathvizor.com/real_estate/${selectedLead.lead_id}`) // Replace with your API endpoint
        .then((response) => {
          setRealEstate(response.data.filter((property) => property.occupancy_type === 'OWN'));
        })
        .catch(() => {
          setRealEstate(null);
        });
        axios.get(`https://api.pathvizor.com/leads/${selectedLead.lead_id}/real_estate_transactions`) // Replace with your API endpoint
        .then((response) => {
          setRealEstateTransactions(response.data);
        })
        .catch(() => {
          setRealEstateTransactions(null);
        });
        axios.get(`https://api.pathvizor.com/business_deals/${selectedLead.company_pbid}`) // Replace with your API endpoint
        .then((response) => {
          setCompanyDeals(response.data);
        })
        .catch(() => {
          setCompanyDeals(null);
        });
  }, []);




  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '80%',
        height: '100%',
        bgcolor: 'background.paper',
        padding: 4,
        borderRadius: 2,
        boxShadow: 24,
        overflowY: 'auto',
      }}
    >
  <Box sx={{ marginBottom: 4 }}>
    <Typography variant="h4" fontWeight="bold" gutterBottom>
      {selectedLead?.name || 'N/A'}
    </Typography>
    <Grid container spacing={2}>
      <Grid item xs={6} sx={{ width: '50%' }}>
        <Typography variant="body1">
          <strong>Company:</strong> {selectedLead?.CompanyName || 'N/A'}
        </Typography>
        <Typography variant="body1">
          <strong>Job Title:</strong> {selectedLead?.JobTitle || 'N/A'}
        </Typography>
        <Typography variant="body1">
          {
            selectedLead?.almaMater ? (
              <>
                <strong>Alma Mater:</strong> {selectedLead?.almaMater}
              </>
            ) : (
              <>
              <strong>Education:</strong> {selectedLead?.EducationLevel || 'N/A'}
              </>
            )
          }
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body1">
          <strong>Phone:</strong> {selectedLead?.MobilePhone || 'N/A'}
        </Typography>
        <Typography variant="body1">
          <strong>Email:</strong> {selectedLead?.Email || 'N/A'}
        </Typography>
        <Typography variant="body1">
          <strong>LinkedIn:</strong>{' '}
          <a
            href={selectedLead?.Linkedin || '#'}
            target="_blank"
            rel="noopener noreferrer"
          >
            {selectedLead?.Linkedin || 'N/A'}
          </a>
        </Typography>
      </Grid>
    </Grid>
  </Box>

  <Box sx={{ borderBottom: '2px solid #e0e0e0', marginBottom: 4 }} />

  <Box sx={{ marginBottom: 4 }}>
    <Grid container spacing={2}>
      <Grid item xs={6} sx={{ width: '50%' }}>
        <Typography variant="body1">
        <strong>Estimated Net Worth:</strong> {selectedLead?.netWorth || 'N/A'}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body1">
          <strong>Inferred Income:</strong> $500,000
        </Typography>
      </Grid>
    </Grid>
  </Box>

  <Box sx={{ borderBottom: '2px solid #e0e0e0', marginBottom: 4 }} />

  {
    (selectedLead && realEstate && realEstate.length > 0) ? (
      <Box sx={{ marginBottom: 4 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Real Estate
      </Typography>
      {realEstate.map((property) => (
      <Grid container spacing={2}>
      <Grid item xs={6} sx={{ width: '50%' }}>
        <Typography variant="body1">
          {property?.street_1 || 'N/A'}
        </Typography>
        <Typography variant="body1">
          {property?.city || 'N/A'},{' '}
          {property?.state || 'N/A'}{' '}
          {property?.postal_code || 'N/A'}

        </Typography>
        <Typography variant="body1">
          USA
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body1">
          <strong>Estimated Price:</strong> {`$${property.purchase_price}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        </Typography>
        <Typography variant="body1">
          <strong>Purchase Date:</strong> { new Date(property?.start_date).toDateString() || 'N/A'}
        </Typography>
      </Grid>
    </Grid>
      ))}

    </Box>
    ) 
    :
    <Box sx={{ marginBottom: 4 }}>
    <Typography variant="h5" fontWeight="bold" gutterBottom>
      Address
    </Typography>
    <Grid container spacing={2}>
      <Grid item xs={6} sx={{ width: '50%' }}>
        <Typography variant="body1">
          {selectedLead?.PersonalAddressStreet || 'N/A'}
        </Typography>
        <Typography variant="body1">
          {selectedLead?.PersonalAddressCity || 'N/A'},{' '}
          {selectedLead?.PersonalAddressState || 'N/A'}{' '}
          {selectedLead?.PersonalAddressZipCode || 'N/A'}

        </Typography>
        <Typography variant="body1">
          USA
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body1">
          <strong>Home Price:</strong> {selectedLead?.HomePrice || 'N/A'}
        </Typography>
        <Typography variant="body1">
          <strong>Interest Rate:</strong> {selectedLead?.InterestRate || 'N/A'}
        </Typography>
      </Grid>
    </Grid>
  </Box>
  }



  <Box sx={{ borderBottom: '2px solid #e0e0e0', marginBottom: 4 }} />

  {
    selectedLead?.companyName && (
      <>
        <Box sx={{ marginBottom: 4 }}>
    <Typography variant="h5" fontWeight="bold" gutterBottom>
      Company Data
    </Typography>
    <Grid container spacing={2}>
      <Grid item xs={6} sx={{ width: '50%' }}>
        <Typography variant="body1">
          <strong>Company Name:</strong> {selectedLead?.CompanyName || 'N/A'}
        </Typography>
        <Typography variant="body1">
          <strong>Industry:</strong> {selectedLead?.PrimaryIndustry || 'N/A'}
        </Typography>
        <Typography variant="body1">
          <strong>Number of Employees:</strong> {selectedLead?.Employees ? selectedLead?.Employees : selectedLead?.EmployeeRange ? selectedLead?.EmployeeRange : 'N/A'}
        </Typography>
        <Typography variant="body1">
          <strong>Revenue:</strong> {selectedLead?.RevenueRange || 'N/A'}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body1">
          <strong>Employee Since:</strong> {selectedLead?.JobStartDate || 'N/A'}
        </Typography>
        <Typography variant="body1">
          <strong>401k Plan:</strong> {selectedLead?.Has401kData || 'N/A'}
        </Typography>
      </Grid>
    </Grid>
  </Box>

  <Box sx={{ borderBottom: '2px solid #e0e0e0', marginBottom: 4 }} />
      </>
    )
  }

  {employmentHistory.length > 0 ? (
  employmentHistory.map((job, index) => (
    <Box
      key={index}
      sx={{
        marginBottom: 2,
        padding: 2,
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        backgroundColor: '#f9f9f9',
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1">
            <strong>Company:</strong> {job.CompanyName ? job.CompanyName.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : 'N/A'}
          </Typography>
          <Typography variant="body1">
            <strong>Job Title:</strong> {job.title ? job.title.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : 'N/A'}
          </Typography>
          <Typography variant="body1">
            <strong>Employee Range:</strong> {job.EmployeeRange || 'N/A'}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1">
            <strong>Start Date:</strong>{' '}
            {job.start_date ? new Date(job.start_date).toDateString() : 'N/A'}
          </Typography>
          <Typography variant="body1">
            <strong>End Date:</strong>{' '}
            {job.end_date ? new Date(job.end_date).toDateString() : 'Present'}
          </Typography>
          <Typography variant="body1">
            <strong>Location:</strong>{' '}
            {`${job.AddressCity || ''}, ${job.AddressState || ''}, ${
              job.AddressCountry || ''
            }`
              .split(' ')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ') || 'N/A'}
          </Typography>
        </Grid>
      </Grid>
      <Box sx={{ marginTop: 2 }}>
        <Typography variant="body2" color="text.secondary">
          <strong>Website:</strong>{' '}
          {job.Website ? (
            <a
              href={`https://${job.Website}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {job.Website}
            </a>
          ) : (
            'N/A'
          )}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>LinkedIn:</strong>{' '}
          {job.LinkedinCompany ? (
            <a
              href={`https://${job.LinkedinCompany}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {job.LinkedinCompany}
            </a>
          ) : (
            'N/A'
          )}
        </Typography>
      </Box>
    </Box>
  ))
) : (
  <Typography variant="body1" color="text.secondary">
    No employment history available.
  </Typography>
)}

  <Box sx={{ borderBottom: '2px solid #e0e0e0', marginBottom: 4 }} />

  {
    (selectedLead.has_inheritance === true && realEstateTransactions?.transactions?.length > 0 ) ? (
      <Box sx={{ marginBottom: 4 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Real Estate Recently Inherited
        </Typography>
        <DataGrid 
          rows={realEstateTransactions.transactions.filter((property) => property.doc_type === 'TODD')} 
          columns={[
            { field: 'doc_date' , headerName: 'Date Inherited', width: 200,
              renderCell: (params) => (
                <div>
                  {new Date(params.value).toDateString()}
                </div>
              )
            },
            { field: 'street_1', headerName: 'Street Address', width: 200,},
            { field: 'state', headerName: 'State', width: 200,},
            { field: 'postal_code', headerName: 'Zip Code', width: 200,},
            { field: 'country', headerName: 'Country', width: 200,},
            { field: 'year_built', headerName: 'Year Built', width: 200,},
            { field: 'assessment_total', headerName: 'Estimated Value', width: 200, renderCell: (params) => (
              <div>
                $ {(Math.round(params.value / 45) * 100).toLocaleString()}
              </div>
            )},
          ]}   
          getRowId={(row) =>  row.document_id}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }} 
          pageSizeOptions={[10, 25, 100]} />
      </Box>

    ) 
    : <></>
  }

  {
    (realEstateTransactions?.transactions?.length > 0 && realEstateTransactions.transactions.filter((property => ['DEED', 'RPTT', 'RETT'].includes(property.doc_type))).length > 0) ? (
      <Box sx={{ marginBottom: 4 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Recent Real Estate Transactions
        </Typography>
        <DataGrid 
          rows={realEstateTransactions.transactions.filter((property => ['DEED', 'RPTT', 'RETT'].includes(property.doc_type)))} 
          columns={[
            { field: 'doc_date' , headerName: 'Date', width: 200,
              renderCell: (params) => (
                <div>
                  {new Date(params.value).toDateString()}
                </div>
              )
            },
            { field: 'party_role', headerName: 'Transaction Type', width: 150,
              renderCell: (params) => (
                <div>
                  {params.value === "buyer" ? "Bought" : "Sell"}
                </div>
              )
            },
            { field: 'street_1', headerName: 'Street Address', width: 200,},
            { field: 'state', headerName: 'State', width: 100,},
            { field: 'postal_code', headerName: 'Zip Code', width: 100,},
            { field: 'country', headerName: 'Country', width: 100,},
            { field: 'year_built', headerName: 'Year Built', width: 200,},
            { field: 'assessment_total', headerName: 'Estimated Value', width: 200, renderCell: (params) => (
              <div>
                $ {(Math.round(params.value / 45) * 100).toLocaleString()}
              </div>
            )},
          ]}   
          getRowId={(row) =>  row.document_id}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }} 
          pageSizeOptions={[10, 25, 100]} />
      </Box>

    ) 
    : <></>
  }

  {
    (selectedLead?.cik && insiderTrades) ? (
      <Box sx={{ marginBottom: 4 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Insider Trades
        </Typography>
        <DataGrid 
          rows={insiderTrades} 
          columns={[
            { field: 'Ticker' , headerName: 'Ticker', width: 200,
            },
            { field: 'CompanyName', headerName: 'Security Name', width: 200,},
            { field: 'acquired_disposed', headerName: 'Transaction Type', width: 200, renderCell: (params) => (
              <div>
                {params.value === 'A' ? 'Buy' : 'Sell'}
              </div>
            )},
            { field: 'transaction_date', headerName: 'Transaction Date', width: 200, renderCell: (params) => (
              <div>
                {new Date(params.value).toDateString()}
              </div>
            )},
            { field: 'transaction_shares', headerName: 'Transaction Shares', width: 200, 
            },
            { field: 'transaction_price', headerName: 'Transaction Price', width: 200, 
            },
            { field: 'shares_owned_following', headerName: 'Shares Owned Following', width: 200, 
            },
            { field: 'trade_type', headerName: 'Trade Type', width: 200, 
            },
            { field: 'transaction_code', headerName: 'Transaction Code', width: 200,
            },
            { field: 'transaction_form_type', headerName: 'Transaction Form Type', width: 200,
            },
            { field: 'equity_swap_involved', headerName: 'Equity Swap Involved', width: 200, renderCell: (params) => (
              <div>
                {params.value ? 'Yes' : 'No'}
              </div>
            )},
            { field: 'direct_or_indirect', headerName: 'Ownership type', width: 200, renderCell: (params) => (
              <div>
                {params.value === 'D' ? 'Direct' : 'Indirect'}
              </div>
            )},
          ]}   
          getRowId={(row) =>  row.trade_id}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }} 
          pageSizeOptions={[10, 25, 100]} />
      </Box>

    ) 
    : <></>
  }
  {
    (selectedLead?.company_pbid && companyDeals && companyDeals.length > 0) ? (
      <Box sx={{ marginBottom: 4 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Business Development Data
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6} sx={{ width: '50%' }}>
          <Typography variant="body1">
            <strong>Company Name:</strong> {companyDeals[0].CompanyName || 'N/A'}
          </Typography>
          <Typography variant="body1">
            <strong>Industry:</strong> {companyDeals[0].PrimaryIndustry || 'N/A'}
          </Typography>
          <Typography variant="body1">
            <strong>Founded:</strong> {companyDeals[0].FoundedYear || 'N/A'}
          </Typography>
          <Typography variant="body1">
            <strong>Company Website:</strong> {companyDeals[0].Website || 'N/A'}
          </Typography>
          <Typography variant="body1">
            <strong>Phone Number:</strong> {companyDeals[0].HQPhone || 'N/A'}
          </Typography>
        </Grid>

      </Grid>
      <DataGrid 
          rows={companyDeals} 
          columns={[
            { field: 'deal_type' , headerName: 'Deal Type', width: 200,
            },
            { field: 'deal_date', headerName: 'Deal Date', width: 200, renderCell: (params) => (
              <div>
                {new Date(params.value).toDateString()}
              </div>
            )},
            { field: 'deal_amount', headerName: 'Deal Amount', width: 200, renderCell: (params) => (
              <div>
                $ {params.value}
              </div>
            )},
            { field: 'post_valuation', headerName: 'Post Valuation', width: 200, renderCell: (params) => (
              <div>
                $ {params.value}
              </div>
            )},
            { field: 'revenue', headerName: 'Revenue', width: 200, renderCell: (params) => (
              <div>
                $ {params.value}
              </div>
            )}
          ]}   
          getRowId={(row) =>  row.event_pbid}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }} 
          pageSizeOptions={[10, 25, 100]} />
    </Box>
    )
    :<></>
  }
  {
    selectedLead && selectedLead401k ? (
      <Box sx={{ marginBottom: 4 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        401k Details
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6} sx={{ width: '50%' }}>
          <Typography variant="body1">
            <strong>Plan Name:</strong> SAP America, Inc. 401(k) Plan
          </Typography>
          <Typography variant="body1">
          <strong>Assets:</strong> $7,535,277,617
          </Typography>

        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1">
            <strong>Total Number of Options:</strong> 21
          </Typography>

        </Grid>
      </Grid>
      <br></br>
      <DataGrid 
      rows={[
        {
          id: "VFTC Retirement Savings Trust III",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$307,314,841"
        },
        {
          id: "Vanguard Institutional 500 IDX Trust",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$1,279,758,592"
        },
        {
          id: "Vanguard Institutional TTL Bond IDX Trust",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$386,529,608"
        },
        {
          id: "VFTC INST TTL INT ST Market IND Trust",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$441,030,467"
        },
        {
          id: "VFTC INST EXT Market Index Trust",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$364,800,318"
        },
        {
          id: "VFTC Target Retirement INCO Trust PL",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$38,556,669"
        },
        {
          id: "VFTC Target Retirement 2020 TRST PL",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$56,962,190"
        },
        {
          id: "VFTC Target Retirement 2025 TRST PL",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$152,775,237"
        },
        {
          id: "VFTC Target Retirement 2030 TRST PL",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$227,730,070"
        },
        {
          id: "VFTC Target Retirement 2035 TRST PL",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$268,400,546"
        },
        {
          id: "VFTC Target Retirement 2040 TRST PL",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$220,930,173"
        },
        {
          id: "VFTC Target Retirement 2045 TRST PL",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$169,356,375"
        },
        {
          id: "VFTC Target Retirement 2050 TRST PL",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$134,113,172"
        },
        {
          id: "VFTC Target Retirement 2055 TRST PL",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$95,000,050"
        },
        {
          id: "VFTC Target Retirement 2060 TRST PL",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$51,569,517"
        },
        {
          id: "VFTC Target Retirement 2065 TRST PL",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$17,191,079"
        },
        {
          id: "VFTC Target Retirement 2070 TRST PL",
          fundEntity: "Vanguard Fiduciary Trust Company",
          dollarValue: "$3,563,116"
        },
        {
          id: "T. Rowe Price Blue Chip Growth Trust",
          fundEntity: "T. Rowe Price Trust Company",
          dollarValue: "$0"
        },
        {
          id: "Allspring Special Small Cap Value E",
          fundEntity: "Allsring Global Investments",
          dollarValue: "$19,018,208"
        },
        {
          id: "Blackrock Midcap Growth Equity Y",
          fundEntity: "Blackrock Institutional Trust Co",
          dollarValue: "$37,614,340"
        },
        {
          id: "JPMCB Large Cap Growth Fund; CF-A C",
          fundEntity: "JP Morgan Asset Company",
          dollarValue: "$358,074,868"
        },
      ]} 
      columns={[
        { field: 'id', headerName: 'Fund Name', width: 350, 
        },
        { field: 'fundEntity', headerName: 'Fund Entity', width: 350, 
        },
        { field: 'dollarValue', headerName: 'Fund Size', width: 350,
        },
      ]}   
      initialState={{
        pagination: { paginationModel: { pageSize: 10 } },
      }} 
      pageSizeOptions={[10, 25, 100]} />
      <br></br>
                  <Typography variant="body1">
            <a
              href={"https://efast2-filings-public.s3.amazonaws.com/prd/2024/06/21/20240621154315NAL0001918451001.pdf"}
              target="_blank"
              rel="noopener noreferrer"
            >
            <strong>PDF Link</strong> 
            </a>
          </Typography>
    </Box>
    )
    : <></>
  }

  <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', marginTop: 4 }}>
    <Button variant="outlined" color="secondary" onClick={onClose}>
      Close
    </Button>
  </Box>    

    </Box>
  );
}

export default LeadDetails;
